<template>
  <div class="records">
    <div v-if="!isLoggedIn" class="login-panel card">
      <h3>请先登录家长账号</h3>
      <p>登录后可查看自己孩子的大课与小课记录</p>
      <el-button type="success" @click="$router.push('/parent/login?redirect=records')">家长登录</el-button>
    </div>

    <template v-else>
      <div class="header card">
        <div class="header-top">
          <span>{{ parentName }} 家长</span>
          <a @click="handleLogout">退出</a>
        </div>

        <div class="tab-bar">
          <span :class="['tab-item', activeTab === 'group' && 'active']" @click="switchTab('group')">大课</span>
          <span :class="['tab-item', activeTab === 'private' && 'active']" @click="switchTab('private')">小课</span>
        </div>

        <div class="children-list">
          <div
            v-for="child in children"
            :key="child.id"
            :class="['child-card', selectedStudentId === child.id && 'active']"
            @click="selectChild(child.id)"
          >
            <div class="child-name">{{ child.name }}</div>
            <div class="child-hours" v-if="activeTab === 'group'">
              <span class="hours-num">{{ child.remainingHours }}</span>
              <span class="hours-label">大课剩余</span>
            </div>
            <div class="child-hours" v-else>
              <span class="hours-num private-num">{{ child.privateRemainingHours || 0 }}</span>
              <span class="hours-label">小课剩余</span>
            </div>
            <div class="child-meta" v-if="activeTab === 'group'">
              总 {{ child.totalHours }} · 已用 {{ child.usedHours }}
              <span v-if="child.owedHours > 0" class="owed"> · 欠 {{ child.owedHours }}</span>
            </div>
            <div class="child-meta" v-else>
              总 {{ child.privateTotalHours || 0 }} · 已用 {{ child.privateUsedHours || 0 }}
              <span v-if="child.privateOwedHours > 0" class="owed"> · 欠 {{ child.privateOwedHours }}</span>
            </div>
          </div>
        </div>

        <div v-if="children.length > 1" class="filter-bar">
          <span :class="['filter-item', !selectedStudentId && 'active']" @click="selectChild(null)">全部记录</span>
        </div>

        <div v-if="activeTab === 'private'" class="date-filter">
          <el-date-picker v-model="startDate" type="date" value-format="yyyy-MM-dd" placeholder="开始日期" size="small" />
          <span>至</span>
          <el-date-picker v-model="endDate" type="date" value-format="yyyy-MM-dd" placeholder="结束日期" size="small" />
          <el-button type="primary" size="small" @click="searchPrivate">搜索</el-button>
        </div>
      </div>

      <div class="section-title">{{ activeTab === 'group' ? '大课签到记录' : '小课上课记录' }}</div>

      <div class="card record-item" v-for="item in records" :key="item.id">
        <div class="record-header">
          <span class="record-name">{{ item.studentName }}</span>
          <span :class="['record-hours', item.recordStatus === 2 && 'owed']">
            {{ item.recordStatus === 2 ? '欠' : '-' }}{{ item.hoursDeducted }}{{ activeTab === 'private' ? '小课' : '课时' }}
            <template v-if="activeTab === 'private' && item.exchangeGroupHours > 0">（扣大课{{ item.exchangeGroupHours }}）</template>
          </span>
        </div>
        <div class="record-info" v-if="activeTab === 'group'">
          签到方式：{{ item.checkInType === 1 ? '刷脸' : (item.checkInType === 6 ? '大课抵小课' : (item.checkInType === 7 ? '调账' : (item.checkInType === 4 ? '接龙' : (item.checkInType === 5 ? '退课' : '手动')))) }}
          <span v-if="item.recordStatus === 2"> · 欠费待缴</span>
          <span v-if="item.recordStatus === 3"> · 欠费已补缴</span>
        </div>
        <div class="record-info" v-else>
          <span v-if="item.recordStatus === 2">欠费待缴</span>
          <span v-else-if="item.recordStatus === 3">欠费已补缴</span>
          <span v-else-if="item.exchangeGroupHours > 0">大课抵小课</span>
          <span v-else>小课打卡</span>
        </div>
        <div class="record-time">{{ activeTab === 'group' ? item.checkInTime : item.lessonTime }}</div>
      </div>

      <div v-if="records.length === 0 && !loading" class="empty">暂无记录</div>
      <div v-if="loading" class="loading"><i class="el-icon-loading"></i> 加载中...</div>
      <div v-if="hasMore && records.length > 0" class="load-more">
        <el-button size="small" :loading="loading" @click="loadRecords(false)">加载更多</el-button>
      </div>
      <div v-if="!hasMore && records.length > 0" class="no-more">没有更多了</div>
    </template>
  </div>
</template>

<script>
import { getParentProfile, getParentCheckInRecords, getParentPrivateRecords, parentLogoutApi } from '../../api'
import { isParentLoggedIn, getParentName, getParentChildren, parentLogout, updateParentChildren } from '../../utils/auth'

export default {
  name: 'Records',
  data() {
    return {
      isLoggedIn: false,
      parentName: '',
      children: [],
      selectedStudentId: null,
      activeTab: 'group',
      startDate: '',
      endDate: '',
      records: [],
      page: 1,
      size: 20,
      loading: false,
      hasMore: true
    }
  },
  activated() { this.init() },
  mounted() { this.init() },
  methods: {
    init() {
      this.isLoggedIn = isParentLoggedIn()
      this.parentName = getParentName()
      this.children = getParentChildren()
      this.resetRecords()
      if (this.isLoggedIn) {
        this.refreshProfile()
        this.loadRecords(true)
      }
    },
    resetRecords() {
      this.records = []
      this.page = 1
      this.hasMore = true
      this.selectedStudentId = null
    },
    switchTab(tab) {
      if (tab === this.activeTab) return
      this.activeTab = tab
      this.startDate = ''
      this.endDate = ''
      this.records = []
      this.page = 1
      this.hasMore = true
      this.loadRecords(true)
    },
    selectChild(id) {
      this.selectedStudentId = id
      this.records = []
      this.page = 1
      this.hasMore = true
      this.loadRecords(true)
    },
    searchPrivate() {
      this.records = []
      this.page = 1
      this.hasMore = true
      this.loadRecords(true)
    },
    async refreshProfile() {
      try {
        const res = await getParentProfile()
        const profile = res.data || {}
        updateParentChildren(profile.children || [])
        this.parentName = profile.parentName || getParentName()
        this.children = profile.children || []
      } catch (e) {
        if ((e.message || '').indexOf('登录') >= 0) {
          parentLogout()
          this.isLoggedIn = false
          this.children = []
          this.records = []
        }
      }
    },
    async loadRecords(reset) {
      if (!isParentLoggedIn()) return
      this.loading = true
      try {
        const page = reset ? 1 : this.page
        let res
        if (this.activeTab === 'private') {
          res = await getParentPrivateRecords({
            page, size: this.size, studentId: this.selectedStudentId,
            startDate: this.startDate, endDate: this.endDate
          })
        } else {
          res = await getParentCheckInRecords({
            page, size: this.size, studentId: this.selectedStudentId
          })
        }
        const newRecords = (res.data && res.data.records) || []
        this.records = reset ? newRecords : this.records.concat(newRecords)
        this.page = page + 1
        this.hasMore = newRecords.length >= this.size
      } catch (e) {
        if ((e.message || '').indexOf('登录') >= 0) {
          parentLogout()
          this.isLoggedIn = false
        }
      } finally {
        this.loading = false
      }
    },
    handleLogout() {
      this.$confirm('确定退出家长账号？', '退出登录').then(async () => {
        try { await parentLogoutApi() } catch (e) { /* ignore */ }
        parentLogout()
        this.isLoggedIn = false
        this.children = []
        this.records = []
        this.$message.success('已退出')
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.card { background: #fff; border-radius: 12px; padding: 16px; margin-bottom: 12px; box-shadow: 0 2px 8px rgba(0,0,0,0.06); }
.login-panel { text-align: center; padding: 40px 24px; }
.login-panel h3 { margin-bottom: 8px; }
.login-panel p { color: #999; font-size: 14px; margin-bottom: 20px; }
.header-top { display: flex; justify-content: space-between; margin-bottom: 16px; font-size: 15px; }
.header-top a { color: #F56C6C; cursor: pointer; }
.tab-bar { display: flex; border-bottom: 1px solid #eee; margin-bottom: 16px; }
.tab-item { flex: 1; text-align: center; padding: 10px 0; color: #999; cursor: pointer; border-bottom: 2px solid transparent; }
.tab-item.active { color: #409EFF; border-bottom-color: #409EFF; font-weight: bold; }
.children-list { display: flex; flex-direction: column; gap: 10px; }
.child-card {
  border: 1px solid #eee; border-radius: 8px; padding: 12px; cursor: pointer;
}
.child-card.active { border-color: #409EFF; background: #ecf5ff; }
.child-name { font-weight: bold; margin-bottom: 6px; }
.child-hours { display: flex; align-items: baseline; gap: 6px; margin-bottom: 4px; }
.hours-num { font-size: 24px; font-weight: bold; color: #409EFF; }
.hours-num.private-num { color: #67C23A; }
.hours-label { font-size: 12px; color: #999; }
.child-meta { font-size: 12px; color: #999; }
.child-meta .owed { color: #F56C6C; }
.filter-bar { margin-top: 12px; }
.filter-item { font-size: 13px; color: #409EFF; cursor: pointer; padding: 4px 0; }
.filter-item.active { font-weight: bold; }
.date-filter { display: flex; flex-wrap: wrap; align-items: center; gap: 8px; margin-top: 12px; }
.section-title { font-size: 14px; font-weight: bold; color: #666; margin: 8px 0 12px; }
.record-header { display: flex; justify-content: space-between; margin-bottom: 6px; }
.record-name { font-weight: bold; }
.record-hours { color: #409EFF; }
.record-hours.owed { color: #F56C6C; }
.record-info { font-size: 13px; color: #999; margin-bottom: 4px; }
.record-time { font-size: 12px; color: #bbb; }
.empty, .loading, .no-more, .load-more { text-align: center; padding: 20px; color: #999; font-size: 14px; }
</style>
